import { Loader } from "../components";
import { useApi } from "../app/ApiContext";
import { LEAGUE_ID } from "../app/config";
import { useSettings, useStandings } from "../data";
import { OriginHint, PageHeader } from "../ui";
import "./SettingsScreen.css";

export const SettingsScreen = () => {
	const api = useApi();
	const { loading, error, standings } = useStandings(api, LEAGUE_ID);
	const { myEntryId, setMyEntryId } = useSettings();

	return (
		<>
			<PageHeader title="Settings" subtitle="Personalise the site for you" />
			<section className="settings-section">
				<div className="eyebrow settings-heading">Your team</div>
				<p className="settings-help">Your matchup is shown first and highlighted, and your row stands out in the table. This is remembered on this device only.</p>
				<Loader loading={loading} loadingMessage="Fetching Teams" />
				{error && (
				<>
					<p className="error-message">{error}</p>
					<OriginHint />
				</>
			)}
				{!loading && !error && (
					<div className="card team-picker" role="radiogroup" aria-label="Your team">
						<button type="button" role="radio" aria-checked={myEntryId == null} className={`team-option${myEntryId == null ? " selected" : ""}`} onClick={() => setMyEntryId(null)}>
							<div>
								<div className="team-option-name">None</div>
								<div className="team-option-manager">Just watching</div>
							</div>
							<span className="team-option-check">{myEntryId == null ? "SELECTED" : ""}</span>
						</button>
						{standings.map((t) => {
							const selected = t.entry === myEntryId;
							return (
								<button type="button" role="radio" aria-checked={selected} key={t.entry} className={`team-option${selected ? " selected" : ""}`} onClick={() => setMyEntryId(t.entry)}>
									<div>
										<div className="team-option-name">{t.entry_name}</div>
										<div className="team-option-manager">{t.player_name}</div>
									</div>
									<span className="team-option-check">{selected ? "SELECTED" : ""}</span>
								</button>
							);
						})}
					</div>
				)}
			</section>
		</>
	);
};
